import {ENTRYPOINT} from "../config/entrypoint";

export default {
    methods: {
        getFullURL(mediaObject) {
            return mediaObject && mediaObject.contentUrl ? ENTRYPOINT + mediaObject.contentUrl : require('@/assets/image/ludinam_2019.png');
        }
    },
}